import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import actions from './actions';

export function* createOrUpdateSelect() {
    yield takeEvery(actions.CREATE_OR_UPDATE_SELECT_REQUESTED, function* (action) {
        try {
            const pillverySelect = yield call(actions.createOrUpdateSelect, action.payload);
            yield put({ type: actions.CREATE_OR_UPDATE_SELECT_SUCCEEDED, pillverySelect });
        } catch (error) {
            yield put({ type: actions.CREATE_OR_UPDATE_SELECT_FAILED, error: error.response.data.message });
        }
    });
}

export default function* rootSaga() {
    yield all([
        fork(createOrUpdateSelect)
    ]);
}
